import { useApi } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";

export interface MatchExpertsParams {
  leadId: number;
  expertIds: number[];
  markAsMatched?: boolean;
}

export function useMatchExperts() {
  const api = useApi();
  const queryClient = useQueryClient();

  const { mutateAsync, isPending, error, isSuccess } = useMutation({
    mutationFn: async ({ leadId, expertIds, markAsMatched = false }: MatchExpertsParams) => {
      return api.admin.leadsV2.matchExperts({
        params: { id: leadId },
        body: { 
          expert_ids: expertIds,
          mark_as_matched: markAsMatched,
        },
      });
    },
    onSuccess: () => {
      // Invalidate all leads queries to refetch the data
      queryClient.invalidateQueries({ queryKey: ['admin', 'leads-v2'] });
    },
  });

  return {
    mutateAsync,
    isPending,
    error,
    isSuccess,
  };
}

